export const FilterCommonEventType = {
  Change: 'change',
  Click: 'click',
};

export const FilterType = {
  Location: 'location',
  Address: 'address',
  Province: 'province',
  City: 'city',
  BuildingClass: 'buildingClass',
  BuildingType: 'buildingType',
  PropertyType: 'propertyType',
  Price: 'price',
  Beds: 'beds',
  Baths: 'baths',
  BedsBaths: 'bedsBaths',
  More: 'more',
  ChartType: 'chartType',
  TransactionDate: 'transactionDate',
  Community: 'community',
  ListingType: 'listingType',
  ListingStatus: 'listingStatus',
  FinishedArea: 'finishedArea',
  LandSize: 'landSize',
  YearBuilt: 'yearBuilt',
  ParkingSpaces: 'parkingSpaces',
  ParkingTypes: 'parkingTypes',
  GarageSpaces: 'garageSpaces',
  OwnershipType: 'ownershipType',
  OccupancyStatuses: 'occupancyStatuses',
  SuiteAvailability: 'suiteAvailability',
};
